import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getGroupsAPI } from './api';

export const GET_GROUPS = 'getGroups';

export function useGetGroups() {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery([
    GET_GROUPS, tenantId,
  ], () => getGroupsAPI());

  return {
    groups: data?.items || [],
    isLoading,
    isFetching,
    isError,
  };
}

